import React, { useState, useRef } from 'react';
import * as _ from 'lodash';
//utilities
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';
// components
import CommonModal from '../modals/common/Modal';
// services
import SessionStorageService from '../../services/utilities/SessionStorageService';
import DirectApiSettingsApi from '../../services/DirectApiSettings';
// modals
import { Information } from '../modals/common';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';
// pages
import { useGetReloadExternalServiceCooperationPage } from '../../pages/ExternalServiceCooperation';

export default function DirectSuspendGuideModal({ visible, setVisible, isInUse }) {
  const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const reloadAction = useGetReloadExternalServiceCooperationPage();
  const fieldId = SessionStorageService.getFieldId();
  const isSending = useRef(false);
  const confirmAction = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const { data, result, status } = await DirectApiSettingsApi.del(fieldId);
      setVisible(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowErrorModal(true);
      } else {
        setIsShowSuccessModal(true);
      }
    } catch (error) {
      setVisible(false);
      setIsShowErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };
  const onClose = () => {
    setVisible(false);
    reloadAction();
  };
  return (
    <React.Fragment>
      <CommonModal
        visible={visible}
        modalClassName={'DirectDescriptionModal--Suspend'}
      >
        <div className='dialog dialog--modal'>
          <div className='dialog__header'>
            <span className='dialog__title'>
              {isInUse ? messageUtility.getMessage('I-001-582') : messageUtility.getMessage('I-001-567')}
            </span>
          </div>

          <div className='dialog__body'>
            <div className='dialog__text'>
              {isInUse ? messageUtility.getMessage('I-001-583') : messageUtility.getMessage('I-001-568')}
            </div>
          </div>

          <div className='dialog__footer dialog__footer--horizontal'>
            <button className='btn-fixedsize--sub' onClick={onClose}>
              {isInUse ? messageUtility.getMessage('I-000-008') : messageUtility.getMessage('I-000-017')}
            </button>
            <button className='btn-fixedsize--negative' onClick={confirmAction}>
              {isInUse ? messageUtility.getMessage('I-000-254') : messageUtility.getMessage('I-001-569')}
            </button>
          </div>
        </div>
      </CommonModal>
      <DirectSuspendSuccessModal
        visible={isShowSuccessModal}
        setVisible={setIsShowSuccessModal}
        isInUse={isInUse}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
        closeAction={reloadAction}
      />
    </React.Fragment>
  );
}

function DirectSuspendSuccessModal({ visible, setVisible, isInUse }) {
  const reloadAction = useGetReloadExternalServiceCooperationPage();
  return (
    <Information
      visible={visible}
      rootClassName={'DirectDescriptionModal--SuspendSuccess'}
      title={isInUse ? messageUtility.getMessage('I-001-584') : messageUtility.getMessage('I-001-567')}
      message={isInUse ? messageUtility.getMessage('I-001-585') : messageUtility.getMessage('I-001-570')}
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        reloadAction();
        setVisible(false);
      }}
      tabFocus={true}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectSuspendGuideModal.jsx